// extracted by mini-css-extract-plugin
module.exports = {"storyContainer":"StoryContainer_storyContainer__3iBWN","description":"StoryContainer_description__3Fi8x"};